import React from 'react';
import { createUseStyles } from 'react-jss';
import { EnrichedTryOutDevice } from '../../types/diaryTypes';
import DeviceLeft from '../../assets/vectors/DeviceLeft';
import DeviceRight from '../../assets/vectors/DeviceRight';
import theme from '../../constants/Theme';

interface TryOutDevicesProps {
  tryOutDeviceList: EnrichedTryOutDevice[];
  size: 'small' | 'large';
}

const TryOutDevices: React.FC<TryOutDevicesProps> = ({ tryOutDeviceList, size }) => {
  const classes = useStyles();

  // Check if we have devices
  if (!tryOutDeviceList || tryOutDeviceList.length === 0) {
    return null;
  }

  const hasTwoIdenticalDevices =
    tryOutDeviceList.length === 2 && tryOutDeviceList[0].identifier === tryOutDeviceList[1].identifier;

  // If we have two identical devices, just show the description
  if (hasTwoIdenticalDevices) {
    return (
      <div className={size === 'large' ? classes.textLarge : classes.textSmall}>{tryOutDeviceList[0].modelName}</div>
    );
  }

  return (
    <div className={classes.container}>
      {tryOutDeviceList.map((device, index, array) => (
        <div
          key={index}
          className={`${classes.deviceRow} ${array.length === 1 && size === 'large' && classes.extraPadding}`}
        >
          {device.site === 'L' ? <DeviceLeft className={classes.icon} /> : <DeviceRight className={classes.icon} />}
          <div className={size === 'large' ? classes.textLarge : classes.textSmall}>{device.modelName}</div>
        </div>
      ))}
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
  },
  deviceRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
  },
  icon: {
    flexShrink: 0,
  },
  textLarge: {
    fontSize: 16,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.blue,
  },
  textSmall: {
    fontSize: 12,
    color: theme.colors.contrastBlack,
  },
  extraPadding: {
    paddingTop: 12.5,
    paddingBottom: 12.5,
  },
});

export default TryOutDevices;
